class BESSAppCouncilAttributes extends BESSAppBase {

    constructor() {
        super();
        this.node = $('.app-council-attributes');
        this.initialised = false;
        let onUpdateState = this.#onUpdateState.bind(this);
        this.form = {
            website: getMaterialTextControl('website', onUpdateState),
            esdLocalPlanningPolicy: getMaterialTextControl('esd_local_planning_policy', onUpdateState),
            esdPolicyUrl: getMaterialTextControl('council_planning_scheme_url', onUpdateState),
            elevatedTargetsCouncil: getMaterialTextControl('elevated_targets_council', onUpdateState),
            updateButton: this.node.find('.app-update-btn'),
        }
        this.initialised = true;
        this.form.updateButton.bindClickEvent(this, this.#onUpdate);
    }

    #onUpdateState() {
        if (this.initialised) {
            this.form.updateButton.enableControl();
        }
    }

    #onUpdate() {
        this.form.updateButton.disableControl();
        this.form.updateButton.addClass('app-saving');
        BESSApp.instance.services.api.council.updateCouncilAttributes(
            this.form.website.val(),
            '' + this.form.esdLocalPlanningPolicy.val() === "1",
            this.form.esdPolicyUrl.val(),
            '' + this.form.elevatedTargetsCouncil.val() === "1",
            this.#onSaved.bind(this),
        )
    }

    #onSaved() {
        this.doDelayed(function () {
            this.form.updateButton.enableControl();
            this.form.updateButton.removeClass('app-saving');
        }, 1000);
    }
}